<template>
  <b-container>
    <Sector>
      <p class="title" :style="{ color: getExperienceColor }">
        {{ $t('categories.main.header.title') }}
      </p>
      <h1 class="subtitle">{{ $t('categories.main.header.subtitle') }}</h1>
    </Sector>

    <Sector v-if="categoriesResult.length > 0">
      <IconsGrid :categories-list="categoriesResult" :categories-limit="19" />
    </Sector>

    <Sector v-if="mainCategoriesResult.length > 0">
      <Mosaic :items="mainCategoriesResult" />
    </Sector>
  </b-container>
</template>

<script>
import Sector from '@/components/Home/Sector';
import Mosaic from '@/components/Categories/Mosaic';
import IconsGrid from '@/components/Categories/IconsGrid';
import { mapState, mapGetters } from 'vuex';

export default {
  nuxtI18n: {
    paths: {
      en: '/categories',
      de: '/kategorien',
      es: '/categorias',
      pt: '/categorias'
    }
  },
  components: {
    Sector,
    IconsGrid,
    Mosaic
  },
  scrollToTop: true,
  async fetch({ store }) {
    await store.dispatch('categories/LOAD_CATEGORIES');
    await store.dispatch('categories/LOAD_MAIN_CATEGORIES');
    await Promise.all([
      store.dispatch('categories/LOAD_CATEGORY_NICHES', { index: '1' }),
      store.dispatch('categories/LOAD_CATEGORY_NICHES', { index: '2' }),
      store.dispatch('categories/LOAD_CATEGORY_NICHES', { index: '3' }),
      store.dispatch('categories/LOAD_CATEGORY_NICHES', { index: '4' }),
      store.dispatch('categories/LOAD_CATEGORY_NICHES', { index: '5' }),
      store.dispatch('categories/LOAD_CATEGORY_NICHES', { index: '6' }),
      store.dispatch('categories/LOAD_CATEGORY_NICHES', { index: '7' }),
      store.dispatch('categories/LOAD_CATEGORY_NICHES', { index: '8' })
    ]);
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapState('categories', ['categoriesResult', 'mainCategoriesResult']),
    ...mapGetters('experience', ['getExperienceColor'])
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 67px;
  text-align: left;
  letter-spacing: 0.67px;
  text-transform: capitalize;
  opacity: 1;
  margin-top: 0;
  font-weight: 500;
  line-height: 70px;
  margin-bottom: 15px;
  @include min-md {
    font-size: 54px;
    margin: 20px 0 6px;
  }
}
.subtitle {
  font-size: 44px;
  text-align: left;
  letter-spacing: 0.44px;
  color: #4d4d4d;
  text-transform: lowercase;
  opacity: 1;
  @include md {
    font-size: 35px;
  }
}
</style>
